const EmbroideredBlanket = ({ width }) => {
    return (
        <div className={`embroidered-blanket ${width}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.5 251.5">
                <g>
                    <path
                        fill="none"
                        stroke="#404041"
                        strokeMiterlimit="10"
                        strokeWidth="16.45"
                        d="M196.26 243.27V102.48C196.26 76.26 175 55 148.78 55H8.23"
                    ></path>
                    <path
                        fill="none"
                        stroke="#404041"
                        strokeMiterlimit="10"
                        strokeWidth="16.45"
                        d="M243.27 219.88V101.96c0-51.77-41.97-93.74-93.74-93.74H31.73"
                    ></path>
                    <path
                        fill="none"
                        stroke="#404041"
                        strokeMiterlimit="10"
                        strokeWidth="16.45"
                        d="M8.23 8.23H243.26999999999998V243.26999999999998H8.23z"
                    ></path>
                    <path
                        fill="#404041"
                        d="M62.09 116.67l8.6-23.66h9.26v33.53h-6.14V99.39l-9.87 27.3h-4.3l-9.82-27.06v26.92h-5.86V93.02h9.59l8.55 23.66zM114.37 119.64H99.54l-2.69 6.9h-6.38l13.41-33.67h6.47l13.41 33.67h-6.71l-2.69-6.9zm-2.17-5.48l-5.24-13.32-5.24 13.32h10.48zM154.75 119.64h-14.83l-2.69 6.9h-6.38l13.41-33.67h6.47l13.41 33.67h-6.71l-2.69-6.9zm-2.17-5.48l-5.24-13.32-5.24 13.32h10.48z"
                    ></path>
                </g>
            </svg>
        </div>
    )
}

export default EmbroideredBlanket
